import { useForm } from '@mantine/form';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import { isValidPhoneNumber } from 'react-phone-number-input/min';

import { UpdateUserDtoTitleEnum, UpdateUserDto } from 'src/Services/API/generated';

export interface UpdateUserFormValues {
  title: UpdateUserDtoTitleEnum;
  firstName: string;
  lastName: string;
  birthDate: Date;
  phoneNumber: string;
}

export const useUpdateUserForm = () => {
  const { t } = useTranslation();

  return useForm<UpdateUserFormValues, (value: UpdateUserFormValues) => UpdateUserDto>({
    initialValues: {
      title: UpdateUserDtoTitleEnum.Mr,
      firstName: '',
      lastName: '',
      birthDate: new Date(),
      phoneNumber: '',
    },
    validate: {
      title: (value: UpdateUserDtoTitleEnum) =>
        Object.values(UpdateUserDtoTitleEnum).includes(value)
          ? null
          : t('forms.invalidTitle', 'Titre invalide'),

      firstName: (value: string) =>
        value.length < 2
          ? t('forms.firstNameTooShort', 'Le prénom doit contenir au moins 2 caractères')
          : null,

      lastName: (value: string) =>
        value.length < 2
          ? t('forms.lastNameTooShort', 'Le nom doit contenir au moins 2 caractères')
          : null,

      birthDate: (value: Date) => {
        if (!value) return t('forms.birthDateRequired', 'La date de naissance est requise');
        const age = Math.floor((Date.now() - value.getTime()) / (365.25 * 24 * 60 * 60 * 1000));
        return age >= 18 ? null : t('forms.mustBe18', 'Vous devez avoir au moins 18 ans');
      },

      phoneNumber: (value: string) => {
        return isValidPhoneNumber(value)
          ? null
          : t('forms.invalidPhoneNumber', 'Numéro de téléphone invalide');
      },
    },
    transformValues: values => {
      const localDate = dayjs(values.birthDate);

      const utcDate = dayjs.utc(localDate.format('YYYY-MM-DD'));

      return {
        ...values,
        birthDate: utcDate,
      };
    },
  });
};
